// Mobile Navigation Fix - Updated for header_bot structure
$(document).ready(function () {
    console.log('Mobile Navigation Fix loaded');

    // Mobile menu toggle functionality
    $('#wsnavtoggle').on('click', function (e) {
        e.preventDefault();
        console.log('Mobile menu toggle clicked');

        // Add click feedback
        $(this).addClass('clicked');
        setTimeout(() => {
            $(this).removeClass('clicked');
        }, 200);

        // Toggle the mobile menu
        var $wsmenucontainer = $('.wsmenucontainer');
        var $wsmenu = $wsmenucontainer.find('.wsmenu');
        var $overlapbg = $wsmenucontainer.find('.overlapblackbg');

        console.log('wsmenucontainer found:', $wsmenucontainer.length);
        console.log('wsmenu found:', $wsmenu.length);

        if ($wsmenucontainer.hasClass('wsoffcanvasopener')) {
            // Close menu
            $wsmenucontainer.removeClass('wsoffcanvasopener');
            if ($wsmenu.length) {
                $wsmenu.css({
                    'left': '-280px',
                    'display': 'none'
                });
            }
            if ($overlapbg.length) {
                $overlapbg.remove();
            }
            console.log('Menu closed');
        } else {
            // Open menu
            $wsmenucontainer.addClass('wsoffcanvasopener');

            // Ensure wsmenu is properly positioned
            if ($wsmenu.length) {
                $wsmenu.css({
                    'left': '0',
                    'display': 'block',
                    'position': 'fixed',
                    'top': '0',
                    'width': '280px',
                    'height': '100vh',
                    'background': '#fff',
                    'z-index': '10000',
                    'overflow-y': 'auto',
                    'box-shadow': '2px 0 5px rgba(0,0,0,0.3)'
                });
            }

            // Add overlay if it doesn't exist
            if ($overlapbg.length === 0) {
                $wsmenucontainer.append('<div class="overlapblackbg"></div>');
                $overlapbg = $wsmenucontainer.find('.overlapblackbg');
            }

            if ($overlapbg.length) {
                $overlapbg.css({
                    'display': 'block',
                    'position': 'fixed',
                    'top': '0',
                    'left': '0',
                    'width': '100%',
                    'height': '100%',
                    'background': 'rgba(0,0,0,0.5)',
                    'z-index': '9999'
                });
            }

            console.log('Menu opened');
        }
    });

    // Close menu when clicking overlay
    $(document).on('click', '.overlapblackbg', function () {
        var $wsmenucontainer = $('.wsmenucontainer');
        var $wsmenu = $wsmenucontainer.find('.wsmenu');
        var $overlapbg = $wsmenucontainer.find('.overlapblackbg');

        $wsmenucontainer.removeClass('wsoffcanvasopener');
        if ($wsmenu.length) {
            $wsmenu.css({
                'left': '-280px',
                'display': 'none'
            });
        }
        if ($overlapbg.length) {
            $overlapbg.remove();
        }
        console.log('Menu closed via overlay click');
    });

    // Close menu on escape key
    $(document).on('keydown', function (e) {
        if (e.keyCode === 27) { // Escape key
            var $wsmenucontainer = $('.wsmenucontainer');
            if ($wsmenucontainer.hasClass('wsoffcanvasopener')) {
                var $wsmenu = $wsmenucontainer.find('.wsmenu');
                var $overlapbg = $wsmenucontainer.find('.overlapblackbg');

                $wsmenucontainer.removeClass('wsoffcanvasopener');
                if ($wsmenu.length) {
                    $wsmenu.css({
                        'left': '-280px',
                        'display': 'none'
                    });
                }
                if ($overlapbg.length) {
                    $overlapbg.remove();
                }
                console.log('Menu closed via escape key');
            }
        }
    });

    // Ensure mobile menu container exists and is properly structured
    function ensureMobileMenuStructure() {
        var $wsmenucontainer = $('.wsmenucontainer');
        var $wsmenu = $wsmenucontainer.find('.wsmenu');

        if ($wsmenu.length === 0) {
            console.log('Creating mobile menu structure');
            // If wsmenu doesn't exist, create it
            $wsmenucontainer.append('<nav class="wsmenu"></nav>');
            $wsmenu = $wsmenucontainer.find('.wsmenu');
        }

        // Ensure wsmenu has proper initial styles
        if ($wsmenu.length) {
            $wsmenu.css({
                'left': '-280px',
                'display': 'none',
                'position': 'fixed',
                'top': '0',
                'width': '280px',
                'height': '100vh',
                'background': '#fff',
                'z-index': '10000',
                'overflow-y': 'auto',
                'box-shadow': '2px 0 5px rgba(0,0,0,0.3)'
            });
        }

        console.log('Mobile menu structure ensured');
    }

    // Initialize mobile menu structure
    ensureMobileMenuStructure();

    // Re-initialize on window resize
    $(window).on('resize', function () {
        if ($(window).width() <= 768) {
            ensureMobileMenuStructure();
        }
    });

    console.log('Mobile Navigation Fix initialization complete');
});

// jQuery Cookie fallback
if (typeof $.cookie === 'undefined') {
    $.cookie = function (name, value, options) {
        if (typeof value === 'undefined') {
            // Get cookie
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        } else {
            // Set cookie
            if (value === null) {
                value = '';
                options = {expires: -1};
            }
            let expires = '';
            if (options && options.expires) {
                const date = new Date();
                date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
                expires = '; expires=' + date.toUTCString();
            }
            document.cookie = name + '=' + value + expires + '; path=/';
        }
    };
} 